export default __webpack_public_path__ + "static/media/Roboto-Medium.b1f960b6.eot";